import Login from './components/modules/login/UserLogin.vue'
import Dashboard from './components/modules/dashboard/Dashboard.vue'
import store from './store'
import { routes as CommonRoutes, Error404 } from './components/modules/common'
import { routes as ReviewRoutes } from './components/modules/posts'
import { routes as EnterpriseRoutes } from './components/modules/enterprise'
import { routes as ProceedsRoutes } from './components/modules/proceeds'
import { routes as mpIndexRoutes } from './components/modules/mpIndex'
import { routes as MeetingRoutes } from './components/modules/meeting'
import { routes as PersonRoutes } from './components/modules/person'
import { routes as DocumentRoutes } from './components/modules/document'
import { routes as IndustryRoutes } from './components/modules/industry'
import { routes as NewsRoutes } from './components/modules/news'
import { routes as salesRoutes } from './components/modules/sales'
import { routes as companyRoutes } from './components/modules/company'
import { routes as productRoutes } from './components/modules/product'
import { routes as categoryRoutes } from './components/modules/category'
import { routes as analysisRoutes } from './components/modules/analysis'

const routes = [
  {
    name: 'login',
    path: '/login',
    component: Login,
    beforeEnter: (to, from, next) => {
      console.log('to:', to)
      console.log('from:', from)
      if (!store.getters.isAuthenticated) {
        next()
      } else {
        next(from.path ? from.path : '/')
      }
    }
  },
  {
    path: '/',
    component: Dashboard,
    // meta: { requiresAuth: true },
    beforeEnter: (to, from, next) => {
      document.body.className += 'skin-dark sidebar-mini'
      next()
    },
    activate: function () {
      this.$nextTick(function () {
        // => 'DOM loaded and ready'
        // alert('test')
      })
    },
    children: [
      ...ReviewRoutes,
      ...CommonRoutes,
      ...mpIndexRoutes,
      ...EnterpriseRoutes,
      ...ProceedsRoutes,
      ...MeetingRoutes,
      ...NewsRoutes,
      ...PersonRoutes,
      ...DocumentRoutes,
      ...IndustryRoutes,
      ...salesRoutes,
      ...companyRoutes,
      ...productRoutes,
      ...categoryRoutes,
      ...analysisRoutes,
      {
        path: '*',
        component: Error404
      }
    ]
  },
  {
    // not found handler
    path: '*',
    redirect: '/login'
  }
]

export default routes



// WEBPACK FOOTER //
// ./src/routes.js